import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { DateTimeDisplay } from 'ui-components/components/date-time-display/date-time-display';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const ShipDate = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  if (!shipment?.shipDate) {
    return '';
  }

  return <DateTimeDisplay utcTimestamp={shipment.shipDate} />;
};

export const shipDate = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.shipDate,
  name: <FormattedMessage {...ltlShipmentsGridMessages.shipDate} />,
  id: 'shipDate',
  width: 100,
  minWidth: 70,
  index: 5,
  render: (data: { id: string }) => <ShipDate freightShipmentId={data.id} />,
};
